module.exports = __webpack_public_path__ + "img/SR_ICON_Location.53d3c9d8.svg";